import React, { useRef } from 'react';
import { Checkbox } from 'antd';
import { useDrag, useDrop } from 'react-dnd';
import cx from 'classnames';

import Img from '../../../../../components/Img/Img';
import expandedArrow from '../../../../../static/images/common/arrow_top_outline_black_w24_btn.png';
import noneExpandedArrow from '../../../../../static/images/common/arrow_bottom_outline_black_w24_btn.png';
import Button from '../../../../../components/Button';
import { useMainCategoryToggle } from '../../CategoryExhibitManagement/hooks/useMainCategoryToggle';
import SubCategoryItem from '../SubCategoryItem';

const MainCategoryItem = (props) => {
  const { onDelete, mainCategory, selectedExhibitCategoryIdList, onSelectExhibit, order, onDragEnd, index } = props;
  const { arrowRef, subRef, isOpen, toggleSubCategory } = useMainCategoryToggle();
  const mainCategoryNameRef = useRef(null);

  const [{ isDraggingMain }, dragRef] = useDrag(
    () => ({
      type: 'CATEGORY_ITEM',
      item: {
        id: mainCategory.id,
        type: 'MAIN',
        index,
      },
      collect: (monitor) => ({
        isDraggingMain: monitor.isDragging(),
      }),
    }),
    [index],
  );

  const [, dropRef] = useDrop({
    accept: 'CATEGORY_ITEM',
    drop: (item, monitor) => {
      if (!monitor.didDrop()) {
        onDragEnd({
          type: item.type,
          source: {
            index: item.index,
          },
          destination: {
            index: Number(index),
          },
        });
      }
    },
  });

  return (
    <tr ref={dropRef} className="exhibit-category-editable-table-row" onClick={toggleSubCategory}>
      <td ref={dragRef} className={cx('main-category-row', { active: isOpen, 'is-dragging': isDraggingMain })}>
        <div>
          <Checkbox
            checked={selectedExhibitCategoryIdList.includes(mainCategory.id)}
            onChange={(e) => onSelectExhibit(mainCategory, e.target.checked)}
          />
        </div>
        <div className="expand-icon-wrapper">
          {!!mainCategory.children.length && (
            <span className="row-expand-icon" ref={arrowRef}>
              {isOpen ? (
                <Img clickAble={false} src={expandedArrow} />
              ) : (
                <Img clickAble={false} src={noneExpandedArrow} />
              )}
            </span>
          )}
          <span>{order}</span>
        </div>
        <div className="main-category-row-name" ref={mainCategoryNameRef}>
          {`${mainCategory.name}(${mainCategory.productCount})`}
        </div>
        <div>
          <Button isRadius color="primary" text="삭제" onClick={() => onDelete(mainCategory)}>
            삭제
          </Button>
        </div>
      </td>
      {isOpen && (
        <td colSpan="100%">
          <table ref={subRef} className="sub-category-table">
            <tbody>
              {mainCategory.children.map((subCategory, index) => {
                return (
                  <SubCategoryItem
                    key={subCategory.id}
                    type={mainCategory.name}
                    subCategory={subCategory}
                    order={Number(index) + 1}
                    index={index}
                    onSelectExhibit={onSelectExhibit}
                    onDelete={onDelete}
                    onDragEnd={onDragEnd}
                    selectedExhibitCategoryIdList={selectedExhibitCategoryIdList}
                  />
                );
              })}
            </tbody>
          </table>
        </td>
      )}
    </tr>
  );
};

export default MainCategoryItem;
